import React from "react";
import { useVisitDialog } from "./DialogContext";
import { VisitModalLayout } from "./VisitModalLayout";

VisitModalLayout.ContentWrapper = function ContentWrapper({ children }) {
  const { successView } = useVisitDialog();

  return (
 <div className={`${successView ? "max-h-[65vh]" : "max-h-[70vh]"} px-2 overflow-auto`}>
      <div className="view-dialog-content-wrap">{children}</div>
    </div>
  );
};